function handleAsId(element) {
  return element.innerText
    .toLowerCase()
    .replace(/æ/g, "ae")
    .replace(/å/g, "a")
    .replace(/ø/g, "o")
    .replace(/\s/g, "-");
}

const articleContent = document.querySelector(".article-template__content");
const tocLinkContainer = document.querySelector(".toc-links");

if (articleContent) {
  const headlines = articleContent.querySelectorAll("h2");
  headlines.forEach((headline) => {
    const id = handleAsId(headline);
    headline.id = id;
    const headlineLink = `#${id}`;
    const tocLink = `<div class="toc-link-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg><a href="${headlineLink}" class="toc-link">${headline.innerText}</a></div>`;
    tocLinkContainer.innerHTML += tocLink;
  });
}
